(() => {
  const label = document.currentScript?.dataset.previewControlsLabel;
  const start = () => {
    if (!label) return;
    const labelFrame = () => {
      const frame = document.getElementById('PBarNextFrame');
      if (!frame || frame.tagName !== 'IFRAME') return false;
      let source;
      try { source = new URL(frame.src); } catch { return false; }
      if (source.origin !== 'https://cdn.shopify.com' || source.pathname !== '/shopifycloud/preview-bar/index.html') return false;
      if (!frame.getAttribute('title')?.trim() && !frame.getAttribute('aria-label')?.trim() && !frame.getAttribute('aria-labelledby')?.trim()) frame.setAttribute('title', label);
      return true;
    };
    if (labelFrame() || !['unpublished', 'development'].includes(window.Shopify?.theme?.role)) return;
    const observer = new MutationObserver(() => {
      if (labelFrame()) observer.disconnect();
    });
    observer.observe(document.body, {childList: true, subtree: true});
    window.addEventListener('pagehide', () => observer.disconnect(), {once: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
